/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Einvoice_Auto_No_PermissionInputs */

const vi_pos_einvoice_auto_no_permission = /** @type {(inputs: Pos_Einvoice_Auto_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn chưa tự phát hành vì tài khoản của bạn chưa có quyền phát hành hóa đơn. Người có quyền mở đơn này ở màn Đơn hàng để phát hành.`)
};

/**

* @param {Pos_Einvoice_Auto_No_PermissionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_einvoice_auto_no_permission = /** @type {((inputs?: Pos_Einvoice_Auto_No_PermissionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Einvoice_Auto_No_PermissionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_einvoice_auto_no_permission(inputs)
});